import { makeStyles } from '@eagleview/ev-comp-library';

/**
 * Styling associated Sign up component
 */
export default makeStyles({
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  inputText: {
    borderRadius: '4px',
    '& >.Mui-error > fieldset': {
      borderColor: '#BC1616 !important',
    },
  },
  label: {
    color: '#4D5365',
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px', /* 150% */
  },
  error: {
    color: '#BC1616',
    fontFamily: 'Noto Sans',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px', /* 150% */
  },
  asterisk: {
    color: '#BC1616',
  },
});
